export default "__VITE_ASSET__tuAkT8KI__"